var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3F3E3E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.086 6.829c.331 0 .6.268.6.6 0 .303-.226.554-.519.594l-.081.006H6.819c-.313 0-.572.232-.613.535l-.006.084v8.533c0 .313.233.572.535.613l.084.006h8.533c.314 0 .573-.233.614-.535l.005-.084v-4.267c0-.331.27-.6.6-.6.304 0 .555.226.595.519l.005.081v4.267c0 .963-.748 1.75-1.694 1.815l-.125.004H6.82c-.963 0-1.75-.748-1.815-1.695L5 17.181V8.648c0-.963.748-1.751 1.695-1.815l.124-.004h4.267zm4.147-.739c.74-.74 1.938-.74 2.677 0 .74.74.74 1.938 0 2.677l-5.79 5.79c-.077.077-.174.132-.28.158l-2.437.61c-.44.11-.838-.288-.728-.728l.61-2.438c.026-.105.08-.202.157-.279zm1.828.849c-.27-.271-.709-.271-.98 0l-5.674 5.673-.325 1.306 1.305-.326 5.674-5.673c.249-.248.27-.638.062-.91z",
    transform: "translate(-1171 -469) translate(164 90) translate(0 111) translate(987 197) translate(0 65) translate(20 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.a6da79ec0ef12d66f647bbae796a9eb1.svg";
export { ForwardRef as ReactComponent };